import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../contexts/LanguageContext';

// The same burger/collapse treatment the placeholders sidebar gets on mobile, for the handful of
// per-template settings that sit above the editor (contract type, page width/height). They're set
// rarely - usually once when the template is created - so having them permanently occupy a row
// above the editor costs vertical space every time the template is opened just to edit its text.
// Unlike the sidebar's version this collapses on desktop too, since the same reasoning applies
// there and the editor benefits from the room either way.
const EditorOptionsPanel = ({ children }) => {
  const { t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`editor-options${isOpen ? ' is-open' : ''}`}>
      <button
        type="button"
        className="editor-options-toggle"
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
      >
        <FontAwesomeIcon icon={faBars} />
        <span>{t('settings.templateOptions')}</span>
        <FontAwesomeIcon icon={faChevronDown} className="editor-options-chevron" />
      </button>
      <div className="editor-options-body">{children}</div>
    </div>
  );
};

export default EditorOptionsPanel;
